import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import AuthNavbar from '../components/navigations/AuthNavbar';

const AuthenticatedLayout = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  // Redirect to signin if not authenticated, preserve current path so we can return after login
  if (!isAuthenticated || !user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AuthNavbar />
      <div className="pt-16 lg:pt-20">
        {children}
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
